import DOCUMENT_TYPE_CODES from '../constants/document-type-codes';

const INVOICE_FILE_VALUES = {
  [DOCUMENT_TYPE_CODES.PDF]: 'attachPdf',
  [DOCUMENT_TYPE_CODES.PDF_FINGO]: 'attachPdfFingo',
  [DOCUMENT_TYPE_CODES.SIGNED_INVOICE]: 'attachSignedInvoice',
  [DOCUMENT_TYPE_CODES.PURCHASE_ORDER]: 'attachPurchaseOrder',
  [DOCUMENT_TYPE_CODES.HES]: 'attachHes',
  [DOCUMENT_TYPE_CODES.PAYMENT_STATUS]: 'attachPaymentStatus',
  [DOCUMENT_TYPE_CODES.SHIPPING_GUIDEBOOK]: 'attachShippingGuidebook',
  [DOCUMENT_TYPE_CODES.PORTAL_SCREENSHOT]: 'attachPortalScreenshot',
  [DOCUMENT_TYPE_CODES.OTHER]: 'attachOther',
  [DOCUMENT_TYPE_CODES.XML]: 'attachXml',
  [DOCUMENT_TYPE_CODES.AEC]: 'attachAec',
};

export const documentToAttachableList = (document) => {
  const attachables = [];
  const assignments = document.assignmentSet || [];
  if (assignments[0]?.certificate) {
    attachables.push({
      id: 'attachCessionCertificate',
      value: 'attachCessionCertificate',
      documentType: 'attachCessionCertificate',
      label: 'Certificado de cesión',
      companyDocument: assignments[0],
      url: assignments[0].certificate.url,
    });
  }
  const documents = document.company?.documents || [];
  const contract = documents.find(({ documentType }) => documentType === 'contract');
  if (contract) {
    attachables.push({
      id: 'attachFrameworkContract',
      value: 'attachFrameworkContract',
      documentType: 'companyFrameworkContract',
      label: 'Contrato marco',
      companyDocument: contract,
      url: contract.lastFile,
    });
  }
  (document.documents || []).forEach((file) => {
    attachables.push({
      id: file.id,
      value: INVOICE_FILE_VALUES[file.type.code],
      documentType: INVOICE_FILE_VALUES[file.type.code],
      label: file.type.name,
      companyDocument: file,
      url: file.file.url,
    });
  });
  return attachables;
};

export const getLastAttachableDocumentsByLabel = (attachableList) => {
  const lastDocumentsMap = new Map();

  attachableList.forEach((document) => {
    lastDocumentsMap.set(document.label, document);
  });

  return Array.from(lastDocumentsMap.values());
};

export const getUniqueAttachableDocuments = (invoice) => {
  if (!invoice) return [];

  return getLastAttachableDocumentsByLabel(documentToAttachableList(invoice));
};

export const getUniqueAttachableDocumentsCount = (invoice) => (
  getUniqueAttachableDocuments(invoice).length
);

export default documentToAttachableList;
